// Central registry of blog posts so Blog index, sitemap, and RelatedReads stay in sync.

import springBreakImage from "@/assets/blog/spring-break-card.jpg";
import tubingCardImage from "@/assets/gallery/friends-tubing.jpg";
import kidsCardImage from "@/assets/gallery/kids-playing-river.jpg";
import tubingKidsCard from "@/assets/tubing/kid-tubing.jpg";
import tubeRentalCard from "@/assets/tubing/sons-tubes-stacked.jpg";
import cabanaPriceCard from "@/assets/cabanas/whats-included.jpg";
import riverRoadCard from "@/assets/gallery/aerial-river-cabanas.jpg";
import bestTimeCard from "@/assets/gallery/tubing-canyon-view.jpg";
import schlitterbahnCard from "@/assets/tubing/family-tubing-fun.jpg";
import packingCard from "@/assets/tubing/friends-floating-cooler.jpg";
import safetyCard from "@/assets/gallery/clear-river.jpg";
import memorialDayCard from "@/assets/gallery/aerial-cabanas.jpg";

export interface BlogPostMeta {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  image: string;
  tags?: string[];
}

export const BLOG_POSTS: BlogPostMeta[] = [
  {
    slug: "memorial-day-weekend-guadalupe-river",
    title: "Memorial Day Weekend on the Guadalupe River — 2026 Cabanas & Tubing Guide",
    excerpt:
      "Plan the perfect Memorial Day weekend on the Guadalupe River — what's open at Son's, booking deadlines, pricing, kid tips, and how to skip the crowds.",
    date: "May 9, 2026",
    image: memorialDayCard,
    tags: ["seasonal", "tubing", "cabanas"],
  },
  {
    slug: "river-road-new-braunfels-guide",
    title: "River Road New Braunfels — Cabanas, Camping & Tubing Guide",
    excerpt:
      "The complete guide to River Road in New Braunfels — cabana rentals, tubing the Guadalupe, glamping, and tent camping on Texas's most iconic river road.",
    date: "May 9, 2026",
    image: riverRoadCard,
    tags: ["river-road", "guide"],
  },
  {
    slug: "best-time-to-tube-guadalupe-river",
    title: "Best Time to Tube the Guadalupe River — Month-by-Month Guide",
    excerpt:
      "When is the best time to tube the Guadalupe? A month-by-month breakdown of river flow, weather, crowds, and the sweet-spot weeks for family floats.",
    date: "May 9, 2026",
    image: bestTimeCard,
    tags: ["tubing", "guide"],
  },
  {
    slug: "schlitterbahn-vs-tubing-guadalupe",
    title: "Schlitterbahn vs. Tubing the Guadalupe — Which Is Better for Families?",
    excerpt:
      "Cost, crowds, kid-friendliness — an honest head-to-head comparison of Schlitterbahn and tubing the Guadalupe River near New Braunfels.",
    date: "May 9, 2026",
    image: schlitterbahnCard,
    tags: ["tubing", "comparison"],
  },
  {
    slug: "what-to-pack-tubing-guadalupe-river",
    title: "What to Pack for Tubing the Guadalupe River — Family Checklist",
    excerpt:
      "The complete family packing list for a day tubing the Guadalupe River — what to bring, what to leave home, and the cabana pro-tip that simplifies everything.",
    date: "May 9, 2026",
    image: packingCard,
    tags: ["tubing", "checklist"],
  },
  {
    slug: "guadalupe-river-water-levels-safety",
    title: "Guadalupe River Water Levels & Safety — Family Guide",
    excerpt:
      "Flow rates, life jackets, and what families should know about Guadalupe River safety before tubing near New Braunfels.",
    date: "May 9, 2026",
    image: safetyCard,
    tags: ["tubing", "safety"],
  },
  {
    slug: "cabana-rentals-price-whats-included",
    title: "Cabana Rentals on the Guadalupe River — Price & What's Included",
    excerpt:
      "Cabana rentals near New Braunfels start at $69. See pricing, what's included (picnic table, parking, river access, 6 guests) and how to book.",
    date: "May 5, 2026",
    image: cabanaPriceCard,
    tags: ["cabanas"],
  },
  {
    slug: "guadalupe-river-tube-rental-near-new-braunfels",
    title: "Guadalupe River Tube Rental Near New Braunfels — Prices & How It Works",
    excerpt:
      "Tube rental prices, what's included, and why renting through Son's Guadalupe is the easiest way to float the Guadalupe River.",
    date: "May 5, 2026",
    image: tubeRentalCard,
    tags: ["tubing"],
  },
  {
    slug: "tubing-with-kids-guadalupe-river",
    title: "Tubing With Kids on the Guadalupe River — A Parent's Guide",
    excerpt:
      "Best ages, life jackets, calm stretches, what to pack, and why a cabana rental makes family tubing on the Guadalupe stress-free.",
    date: "May 5, 2026",
    image: tubingKidsCard,
    tags: ["tubing", "kids"],
  },
  {
    slug: "fun-things-to-do-with-kids-near-new-braunfels",
    title: "10 Fun Things to Do With Kids Near New Braunfels (Beyond the Tube)",
    excerpt:
      "From tubing the Guadalupe River to Schlitterbahn, Natural Bridge Caverns, glamping, and campfire s'mores — the ultimate guide to family getaways near New Braunfels.",
    date: "May 5, 2026",
    image: kidsCardImage,
    tags: ["kids", "things-to-do"],
  },
  {
    slug: "tubing-guadalupe-river-new-braunfels",
    title: "Tubing the Guadalupe River Near New Braunfels — The Ultimate Family Guide",
    excerpt:
      "Your complete guide to tubing the Guadalupe River near New Braunfels — cabana rentals, kayaking, family fun things to do in New Braunfels, and insider tips for the best float of the summer.",
    date: "May 5, 2026",
    image: tubingCardImage,
    tags: ["tubing", "guide"],
  },
  {
    slug: "spring-break-2026-sons-river-ranch",
    title: "Spring Break 2026 at Son's River Ranch — We're Open & the River Is Calling!",
    excerpt:
      "The river is flowing, the weather is warm, and Son's River Ranch is officially open for spring break. Grab the family and make memories that last a lifetime.",
    date: "March 14, 2026",
    image: springBreakImage,
    tags: ["seasonal"],
  },
];

export const getRelatedPosts = (currentSlug: string, count = 3): BlogPostMeta[] => {
  const current = BLOG_POSTS.find((p) => p.slug === currentSlug);
  if (!current) return BLOG_POSTS.slice(0, count);
  const others = BLOG_POSTS.filter((p) => p.slug !== currentSlug);
  // Sort by overlapping tag count, then most recent
  const scored = others
    .map((p) => ({
      post: p,
      score: (p.tags || []).filter((t) => current.tags?.includes(t)).length,
    }))
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, count).map((s) => s.post);
};
